import { Environment } from '@thiememeulenhoff/types';
import { toegangClientSecret } from '@thiememeulenhoff/ng-sdk';
import { EnvironmentType } from './environment.type';

export const environment: EnvironmentType = {
  environment: Environment.Test,
  vestaUrl: 'https://test.vesta.thiememeulenhoff.nl/admin',
  unleash: {
    instance: 'eu.app.unleash-hosted.com/euee0007',
    clientKey:
      '*:development.9fcfa139893173c16ee5fae24b057c205de41bf1da110a43f428a340',
    environment: 'development',
    refreshInterval: 5 * 60, // 5 minutes
    metricsInterval: 15 * 60, // 15 minutes
  },
  auth: {
    environment: Environment.Test,
    clientId: 'edu-admin',
    clientSecret: toegangClientSecret('EDU_ADMIN'),
    useUserCookie: false,
  },
  tham: {
    proxyDomain: 'https://d1s17n93wzfusy.cloudfront.net',
  },
};
